import { PERMISSION_KEYS } from '@/features/conversation';
import { Authorize } from '@/shared/components/authorize';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { Pin, PinOff } from 'lucide-react';
import type { FC } from 'react';
import type { Message } from '../../models/message';
import { useMessagePin } from '../../queries/use-message-pin';
import { useMessageDeletePin } from '../../queries/use-message-pin-delete';

interface PinedMenuItemProps {
  msg: Message;
  onClose: () => void;
}

export const PinedMenuItem: FC<PinedMenuItemProps> = ({ msg, onClose }) => {
  const { mutateAsync, isPending } = useMessagePin(msg.conversationId, msg.messageId);
  const { xoa, isDeleting } = useMessageDeletePin(msg.conversationId);

  const handlePined = async () => {
    await mutateAsync({
      bucketId: msg.bucketId
    });
    onClose();
  };

  const handleUnpined = async () => {
    await xoa(msg.messageId, msg.bucketId);
    onClose();
  };

  return (
    <Authorize conversationId={msg.conversationId!} permissions={[PERMISSION_KEYS.MESSAGE_PIN]}>
      <MenuItem onClick={msg.pinned ? handleUnpined : handlePined} disabled={isPending || isDeleting}>
        <ListItemIcon>{msg.pinned ? <PinOff /> : <Pin />}</ListItemIcon>
        <ListItemText>{msg.pinned ? 'Bỏ ghim' : 'Ghim'}</ListItemText>
      </MenuItem>
    </Authorize>
  );
};
